// extracted by mini-css-extract-plugin
module.exports = {"center":"ModalHub_center__4ZscK","backdrop":"ModalHub_backdrop__rr6fp"};